export default __webpack_public_path__ + "static/media/dropImage2.0ada2e6f.PNG";